document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".product__tax.caption.rte");
  const insertAfterElement = document.querySelector(
    ".tee-block.tee-product-price"
  );
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
    elementToMove.style.paddingBottom = "12px";
  }

  const observer = new MutationObserver(() => {
  const moved = moveElementAfter('.goodsc-link', '.tee-option--size');
    if (moved) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
    return true;
  }
  return false;
};
